import { Caption, H2, LabelRegular } from '@comeon/ui';
import styled from 'styled-components';
import SportsbookTextKeys from '../../sportsbook-text-keys';
import { useTypedTranslationsWithPartialResult } from '../../../../translation/use-translations';
import AnimatedDots from './animated-dots';

const FlexRow = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	height: 37px;
	background-color: var(--main-background);
	border-radius: var(--base-radius-medium);
`;

const FlexColumn = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 12px;
`;

const OddsUpdatingLabel = styled(Caption)`
	opacity: 0.25;
	color: var(--main-text);
`;

type Props = {
	label?: string;
	children?: React.ReactNode;
	className?: string;
};

/**
 * Inline version of the odds updating component. Description is removed, animated dots and label are smaller.
 */
export const SportsbookOddsUpdatingInline: React.FC<Props> = ({ label, children, className }) => {
	const { translations } = useTypedTranslationsWithPartialResult(SportsbookTextKeys);

	return (
		<FlexRow className={className}>
			<OddsUpdatingLabel>
				{label || children || translations[SportsbookTextKeys.ODDS_UPDATING_LABEL]}
				...
			</OddsUpdatingLabel>
		</FlexRow>
	);
};

type BlockProps = Props & {
	description?: string;
};

export const SportsbookOddsUpdating: React.FC<BlockProps> = ({ label, children, description, className }) => {
	const { translations } = useTypedTranslationsWithPartialResult(SportsbookTextKeys);

	return (
		<FlexColumn className={className}>
			<AnimatedDots.Regular />
			<H2>{label || children || translations[SportsbookTextKeys.ODDS_UPDATING_LABEL]}</H2>
			{description && <LabelRegular>{description}</LabelRegular>}
		</FlexColumn>
	);
};
